var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Edit"}},[_c('button',{on:{"click":_vm.remove}},[_vm._v("삭제")]),_c('span',{staticClass:"line"},[_vm._v("|")]),_c('button',{on:{"click":_vm.edit}},[_vm._v("수정")])])}
var staticRenderFns = []

export { render, staticRenderFns }